import React from "react";

function Galery() {
  return (
    <>
      <p className="text-white text-3xl font-bold p-4 text-center mb-4">
        Best Photo 2023
      </p>
      <div class="grid grid-cols-2 md:grid-cols-4 gap-4 ">
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/1.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/2.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/3.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/4.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/5.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/6.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/7.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/8.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/9.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/10.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/11.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/12.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/13.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/14.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/15.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/16.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/17.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/18.jpg"
            alt=""
          />
        </div>

        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/20.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/21.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/22.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/23.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/24.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            class="h-auto max-w-[90%] mx-auto rounded-lg"
            src="https://www.dheep.site/2023img/25.jpg"
            alt=""
          />
        </div>
      </div>
    </>
  );
}

export default Galery;
